import { Link } from 'react-router-dom'

export default function Hero() {
  return (
    <section className="relative px-4 sm:px-8 py-16 sm:py-24 overflow-hidden">

      {/* Background Image with dark overlay */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: "url('/images/dsms_hero.png')" }}
      />
      {/* Dark overlay for readability */}
      <div className="absolute inset-0 bg-black/60 dark:bg-black/70" />

      {/* Background decorative circles */}
      <div className="absolute top-0 right-0 w-64 sm:w-96 h-64 sm:h-96 rounded-full border border-green-900/30 -translate-y-1/2 translate-x-1/2 pointer-events-none" />
      <div className="absolute top-0 right-0 w-40 sm:w-64 h-40 sm:h-64 rounded-full border border-green-800/40 -translate-y-1/4 translate-x-1/4 pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-56 sm:w-80 h-56 sm:h-80 rounded-full border border-green-900/20 translate-y-1/2 -translate-x-1/2 pointer-events-none" />

      {/* All content needs relative + z-10 to sit above overlay */}
      <div className="relative z-10">

        {/* Badge */}
        <div className="inline-block bg-green-900/30 border border-green-800/50 px-4 py-1 text-xs tracking-widest uppercase text-green-400 mb-6">
          Welcome to the Mighty Mufulira Wanderers Supporters Society.
        </div>

        {/* Heading */}
        <h1 className="text-4xl sm:text-5xl lg:text-7xl font-black uppercase leading-none tracking-tight mb-6 max-w-3xl text-white">
          Your Club.<br />
          <span className="text-green-500">Your</span><br />
          Community.
        </h1>

        {/* Subtext */}
        <p className="text-gray-300 text-base sm:text-lg max-w-xl leading-relaxed mb-8 sm:mb-10">
          The digital platform connecting football supporters, clubs, and communities across Africa.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
          <Link
            to="/shop"
            className="border border-green-500/70 text-green-400 hover:bg-green-900/30 px-8 py-4 font-bold uppercase tracking-widest text-sm transition-colors text-center"
          >
            Visit Shop
          </Link>
          <Link
            to="/login"
            className="border border-white/30 text-white/70 hover:bg-white/10 hover:text-white px-8 py-4 font-bold uppercase tracking-widest text-sm transition-colors text-center"
          >
            Sign In
          </Link>
        </div>
      </div>
    </section>
  )
}